import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

function Historicos() {
// Estado de filtros
const [filters, setFilters] = useState({
empresa: "",
fechaInicio: "",
fechaFin: "",
plan: "",
estado: "",
});

// Aquí en el futuro vas a traer los datos desde el backend
const [rows, setRows] = useState([]);

// Columnas de la tabla
const columns = [
{ Header: "Fecha de compra", accessor: "fecha_compra", align: "center" },
{ Header: "Plan", accessor: "plan", align: "center" },
{ Header: "Método de pago", accessor: "metodo_pago", align: "center" },
{ Header: "Valor", accessor: "valor", align: "center" },
{ Header: "Periodicidad", accessor: "periodicidad", align: "center" },
{ Header: "Renovación automática", accessor: "renovacion_automatica", align: "center" },
{ Header: "Estado", accessor: "estado", align: "center" },
];

const handleFilterChange = (e) => {
const { name, value } = e.target;
setFilters((prev) => ({ ...prev, [name]: value }));
};

const handleFilter = () => {
console.log("Filtrando con:", filters);
// Aquí más adelante harás la consulta al backend
};

return ( <DashboardLayout> <DashboardNavbar /> <MDBox pt={6} pb={3}> <Grid container spacing={6}> <Grid item xs={12}> <Card> <MDBox
             mx={2}
             mt={-3}
             py={3}
             px={2}
             variant="gradient"
             bgColor="info"
             borderRadius="lg"
             coloredShadow="info"
           > <MDTypography variant="h6" color="white">
            Históricos
            </MDTypography> </MDBox>

          {/* Filtros */}
          <MDBox p={3}>
            <Grid container spacing={2} alignItems="center">
              {/* Empresa */}
              <Grid item xs={12} md={6} lg={4}>
                <MDTypography variant="button" fontWeight="medium">
                  Nombre Empresa
                </MDTypography>
                <TextField
                  select
                  fullWidth
                  name="empresa"
                  value={filters.empresa}
                  onChange={handleFilterChange}
                  size="small"
                  variant="outlined"
                  placeholder="Seleccione..."
                >
                  <MenuItem value="">Seleccione...</MenuItem>
                </TextField>
              </Grid>

              {/* Rango de fechas */}
              <Grid item xs={6} md={3} lg={2}>
                <TextField
                  fullWidth
                  type="date"
                  name="fechaInicio"
                  value={filters.fechaInicio}
                  onChange={handleFilterChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={6} md={3} lg={2}>
                <TextField
                  fullWidth
                  type="date"
                  name="fechaFin"
                  value={filters.fechaFin}
                  onChange={handleFilterChange}
                  size="small"
                />
              </Grid>

              {/* Plan */}
              <Grid item xs={6} md={3} lg={2}>
                <TextField
                  select
                  fullWidth
                  name="plan"
                  value={filters.plan}
                  onChange={handleFilterChange}
                  size="small"
                  variant="outlined"
                >
                  <MenuItem value="">Seleccione plan</MenuItem>
                </TextField>
              </Grid>

              {/* Estado */}
              <Grid item xs={6} md={3} lg={2}>
                <TextField
                  select
                  fullWidth
                  name="estado"
                  value={filters.estado}
                  onChange={handleFilterChange}
                  size="small"
                  variant="outlined"
                >
                  <MenuItem value="">Seleccione estado</MenuItem>
                  <MenuItem value="vigente">Vigente</MenuItem>
                  <MenuItem value="cancelado">Cancelado</MenuItem>
                  <MenuItem value="pendiente">Pendiente</MenuItem>
                </TextField>
              </Grid>

              {/* Botón Filtrar */}
              <Grid item xs={12} md={2} lg={1}>
                <Button
                  variant="contained"
                  color="info"
                  fullWidth
                  onClick={handleFilter}
                  startIcon={<Icon>filter_alt</Icon>}
                >
                  Filtrar
                </Button>
              </Grid>
            </Grid>

            {/* Botones de acción */}
            <MDBox display="flex" justifyContent="flex-end" mt={3} gap={2}>
              <Button
                variant="contained"
                color="info"
                startIcon={<Icon>picture_as_pdf</Icon>}
              >
                Descargar PDF
              </Button>
              <Button
                variant="contained"
                color="info"
                startIcon={<Icon>file_download</Icon>}
              >
                Descargar CSV
              </Button>
            </MDBox>
          </MDBox>

          {/* Tabla */}
          <MDBox pt={3} pb={3} px={3}>
            <DataTable
              table={{ columns, rows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  </MDBox>
  <Footer />
</DashboardLayout>


);
}

export default Historicos;
